const SocialMediaIcons = () => {
  return (
    <div className="flex justify-center md:justify-start my-10 gap-7">
      <a
        className="hover:opacity-50 transition duration-500"
        href="https://www.linkdein.com"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="linkdein-link" src="../assets/linkedin.png" />
      </a>
      <a
        className="hover:opacity-50 transition duration-500"
        href="https://www.linkdein.com"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="linkdein-link" src="../assets/twitter.png" />
      </a>
      <a
        className="hover:opacity-50 transition duration-500"
        href="https://www.linkdein.com"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="linkdein-link" src="../assets/facebook.png" />
      </a>
      <a
        className="hover:opacity-50 transition duration-500"
        href="https://www.linkdein.com"
        target="_blank"
        rel="noreferrer"
      >
        <img alt="linkdein-link" src="../assets/instagram.png" />
      </a>
    </div>
  );
};

export default SocialMediaIcons;
